export default "//consumer.prod.ableto.com/images/meta_og_logo-4ccb30e73626fcbf51156f6881a0f635.png";